@if (photos().length > 0) {
  @if (embedded()) {
    <div class="media-photos-grid media-photos-grid--embedded">
      @if (showTitle()) {
        <h4 class="media-photos-grid__title media-photos-grid__title--embedded">
          {{ titleKey() | translate }}
        </h4>
      }
      <div class="media-photos-grid__grid">
        @for (photo of photos(); track photo._id ?? $index) {
          <button
            type="button"
            class="media-photos-grid__photo-btn"
            (click)="openGalleryDialog(photo)">
            <img
              class="media-photos-grid__photo"
              [ngSrc]="photoSrc(photo)"
              [pwjMediaImageFallback]="photo"
              pwjMediaImageFallbackFrom="cropped_thumbnail"
              [width]="imageWidth()"
              [height]="imageHeight()"
              alt="" />
          </button>
        }
      </div>
    </div>
  } @else {
    <section class="media-photos-grid">
      @if (showTitle()) {
        <h3 class="media-photos-grid__title">{{ titleKey() | translate }}</h3>
      }
      <div class="media-photos-grid__grid">
        @for (photo of photos(); track photo._id ?? $index) {
          <button
            type="button"
            class="media-photos-grid__photo-btn"
            (click)="openGalleryDialog(photo)">
            <img
              class="media-photos-grid__photo"
              [ngSrc]="photoSrc(photo)"
              [pwjMediaImageFallback]="photo"
              pwjMediaImageFallbackFrom="cropped_thumbnail"
              [width]="imageWidth()"
              [height]="imageHeight()"
              alt="" />
          </button>
        }
      </div>
    </section>
  }
}
